import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { TwitchAuthProvider } from './context/TwitchAuthContext';
import { SiteConfigProvider } from './context/SiteConfigContext';
import { ensureLatestVersion } from './ensureLatestVersion';
import { redirectToCanonicalSite } from './constants/site';

const rootEl = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootEl);

function renderApp() {
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <SiteConfigProvider>
          <TwitchAuthProvider>
            <App />
          </TwitchAuthProvider>
        </SiteConfigProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}

if (redirectToCanonicalSite()) {
  /* recarga en eugenial.com.ar sin www */
} else {
  ensureLatestVersion().then(renderApp);
}
